import ImageSelector from '@di-shared/features/common/ImageSelector';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import React from 'react';

export default function IntroduceBottomSheetEu() {
  const {t} = useInferableTranslation();

  return (
    <div className="bottom_sheet bottom_sheet_intro_guide">
      <div className="bottom_sheet_header">
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('ctn_home_close')}
          onClick={() => window.bottomSheetClose(false)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="intro_guide_title">
            <span
              className="title_text"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('msg_home_bottom_introduction_01')}
            </span>
            <span
              className="ic logo_driving_insight"
              role="img"
              aria-label={t('ctn_home_title_drivinginsight')}
            />
          </strong>
          <div className="intro_guide_imgbox">
            <ImageSelector
              className="intro_guide_img"
              alt="intro_guide_img"
              kiaLightSrc={() => import('@di-shared/assets/img/home/intro_guide_eu_light.png')}
              kiaDarkSrc={() => import('@di-shared/assets/img/home/intro_guide_eu.png')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/home/hyundai/intro_guide_eu_light.png')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/home/hyundai/intro_guide_eu.png')}
              genesisLightSrc={() => import('@di-shared/assets/img/home/genesis/intro_guide_eu_light.png')}
              genesisDarkSrc={() => import('@di-shared/assets/img/home/genesis/intro_guide_eu.png')}
            />
          </div>
        </div>

        <div className="bottom_sheet_footer">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose(true)}
          >
            {t('msg_home_bottom_introduction_02')}
          </button>
        </div>
      </div>
    </div>
  );
}
